import React from "react";
import { Layout, Row, Col, QRCode, Typography, Button } from "antd";
import { useSelector } from "react-redux";
// redux
import icon from "asset/img/logo/vivn.png";
import LayoutHeader from "./layout_header";
import { emailSelector } from "store/user/auth/user_auth.selector";
import { uidSelector } from "store/bailiff/auth/bailiff_auth.selector";

const { Content } = Layout;
const AllowScreen = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const email = useSelector(emailSelector);
  const uid = useSelector(uidSelector);
  const id = uid;

  // -------------------------- FUNCTION --------------------------
  const handleDownload = async () => {
    const qrCanvas = document
      .getElementById("myqrcode")
      .querySelector("canvas");
    const qrDataURL = qrCanvas.toDataURL(); // Lấy DataURL của QR Code

    if (qrDataURL) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      // Kích thước canvas (tuỳ chỉnh)
      canvas.width = 300;
      canvas.height = 300;

      // Vẽ background
      ctx.fillStyle = "#ffffff"; // Màu nền
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Chờ hình QR Code load
      img.onload = () => {
        // Chèn QR Code vào giữa canvas
        const qrSize = 300; // Kích thước QR Code
        const x = (canvas.width - qrSize) / 2;
        const y = (canvas.height - qrSize) / 2;

        ctx.drawImage(img, x, y, qrSize, qrSize);

        // Tạo link tải xuống
        const link = document.createElement("a");
        link.download = `${email}-qr.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      };

      img.src = qrDataURL;
    }
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title="Dịch Vụ Chuyển Âm" />
      <Content className="content">
        <Row justify={"center"} gutter={[10, 10]}>
          <Col
            style={{
              marginTop: 100,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 20,
            }}
            align="center"
            xs={24}
            sm={24}
            md={24}
            lg={24}
          >
            <div id="myqrcode">
              <QRCode
                style={{ background: "#fff" }}
                icon={icon}
                size={300}
                value={id}
              />
            </div>
            <Button
              onClick={handleDownload}
              block
              type="primary"
              style={{ borderRadius: 5, width: 300 }}
            >
              Tải ảnh QR
            </Button>
          </Col>
          <Col align="center" xs={24} sm={24} md={24} lg={24}>
            <Typography.Title level={4}>
              Bạn chưa được cấp quyền vào Dịch Vụ Chuyển Âm
            </Typography.Title>
          </Col>
          <Col align="center" xs={24} sm={24} md={24} lg={24}>
            <Typography.Text type="secondary">
              Xin vui lòng tải ảnh QR mã khách hàng và gửi cho cộng tác viên để
              thêm vào chi nhánh Thừa Phát.
            </Typography.Text>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default AllowScreen;
